import { core } from "@tauri-apps/api";

/**
 * Speichert den Oura Access Token im lokalen SecureStorage.
 *
 * @param token - Der Oura API Token.
 *
 */
export async function saveOuraToken(token: string): Promise<void> {
  await core.invoke("set_oura_token", { token });
}

/**
 * Lädt den gespeicherten Oura Access Token aus dem SecureStorage.
 *
 * @returns Der gespeicherte Token als String.
 *
 */
export async function loadOuraToken(): Promise<string> {
  const token = await core.invoke<string>("get_oura_token");
  return token;
}
